import api from "./api";

export interface User {
    _id?: string;
    id: string;
    email: string;
    password?: string; // Only used for creation, not returned from API
    firstName: string;
    lastName: string;
    businessName?: string;
    phoneNumber: string;
    streetAddress: string;
    city: string;
    country: string;
    postalCode: string;
    // Company fields
    companyName?: string;
    companyPhoneNumber?: string;
    companyStreetAddress?: string;
    companyCity?: string;
    companyCountry?: string;
    companyPostalCode?: string;
    termsAgreed: boolean;
    activeSubscriptionId?: string;
    emailVerified: boolean;
    role: string;
    createdAt?: string;
    updatedAt?: string;
}

export interface UserUpdateData {
    phoneNumber?: string;
    businessName?: string;
    streetAddress?: string;
    city?: string;
    country?: string;
    postalCode?: string;
    companyName?: string;
    companyPhoneNumber?: string;
    companyStreetAddress?: string;
    companyCity?: string;
    companyCountry?: string;
    companyPostalCode?: string;
}

export const userService = {
    getAllUsers: async (): Promise<User[]> => {
        const response = await api.get("/admin/users");
        return response.data;
    },

    getUserById: async (id: string): Promise<User> => {
        const response = await api.get(`/admin/users/${id}`);
        return response.data;
    },

    createUser: async (user: Partial<User>): Promise<User> => {
        const response = await api.post("/admin/users", user);
        return response.data;
    },

    updateUser: async (id: string, user: Partial<User>): Promise<User> => {
        const response = await api.put(`/admin/users/${id}`, user);
        return response.data;
    },

    deleteUser: async (id: string): Promise<void> => {
        await api.delete(`/admin/users/${id}`);
    },

    // New method for updating current user's profile
    updateCurrentUser: async (userData: UserUpdateData): Promise<User> => {
        const token = localStorage.getItem("token");
        const response = await api.patch("/auth/user", userData, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },

    // Method to get current user data
    getCurrentUser: async (): Promise<User> => {
        const token = localStorage.getItem("token");
        const response = await api.get("/auth/user", {
            headers: { Authorization: `Bearer ${token}` }
        });
        return response.data;
    },
};
